module.exports = __webpack_public_path__ + "img/profile-ana.557fad5c.webp";